
import * as React from 'react';

import SimpleMDE from "react-simplemde-editor";
import 'simplemde/dist/simplemde.min.css';

import CKEditor from '../CKEditor';

import { FileEditorController } from '../logic/fileeditor';
import { MimeType } from '../logic/mimeTypes';
import { bufferToString, stringToArrayBuffer } from '../logic/util';

interface IFileEditorProps {
  controller: FileEditorController;
}

interface IEditorProps {
  mimeType : MimeType;
  content : string;
  onChange : (value : string) => void;
}

interface IEditorState {
  content : string
}

const WAIT_INTERVAL = 1000; // 1 sec wait time before saving edited html or md file.

export class FileEditor extends React.Component<IFileEditorProps> {
  protected controller: FileEditorController;
  protected timer : any;
  constructor(props: IFileEditorProps, context: any) {
    super(props, context);
    this.timer = null;
    this.controller = props.controller;

    this.controller.onChange(() => {
        this.forceUpdate();
    });
  }

  public componentWillMount() {
    this.timer = null;
  }
  public render() {
    const template = this.controller.getTemplate();
    if (!template) return null;
    const buffer = this.controller.getBuffer();
    if (!buffer) return null;

    return (
      <div className="FileEditor">
        <h3>Editing {template.filename || 'an unnamed file'}</h3>
        <Editor mimeType={template.mimeType} content={bufferToString(buffer)} onChange={this.onChange}/>
      </div>
    );
  }

  protected triggerChange = (controller: FileEditor, value: string) => {
      this.controller.setBuffer(stringToArrayBuffer(value));
  };

  protected onChange = (value: string) => {
      clearTimeout(this.timer);
      this.timer = setTimeout(() => this.triggerChange(this, value), WAIT_INTERVAL);
  };
}

class Editor extends React.Component<IEditorProps, IEditorState> {
 
  public state = {
    content : this.props.content
  }

  constructor(props : IEditorProps) {
    super(props);
  }

  public render() {
    if(this.props.mimeType === MimeType.html) {
      return (<CKEditor value={this.props.content} onChange={this.props.onChange} />);
    } else if(this.props.mimeType === MimeType.md) {
      return (<SimpleMDE value={this.props.content} onChange={this.props.onChange} />)
    } else return null;
  }
}




export default FileEditor;



// WEBPACK FOOTER //
// ./src/FileEditor/index.tsx